module.exports = __webpack_public_path__ + "img/weddings_27_V.87fa6fbb.webp";